import React, { useContext, useEffect, useRef, useState } from 'react'
import { Content } from './style'
import { OptionsButton, LeftSide, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv, ButtonCreate, RefreshIcon, RefreshIconContainer } from '../../../components/styles/subheader-style'
import stock from '../../../assets/stock/TableMovementHeader/list-active.svg'
import movement from '../../../assets/stock/TableMovementHeader/refresh-active.svg'
import { Outlet, useNavigate, useOutletContext, useLocation } from 'react-router-dom'
import ModalContext from '../../../contexts/ModalContext'
import { TypeMainOutlet } from '..'
import { tableFields } from '../../../components/FieldManager/table-fields'
import FieldsManager, { FieldsManagerType } from '../../../components/FieldManager'
import WithoutSelectedFields from '../../SystemErrors/WithoutSelectedFields'
import StockContext from '../../../contexts/StockContext'
import FiltersMenu from '../../../components/Stock/TableMovementHeader/FiltersMenu'
import filter from '../../../assets/stock/TableMovementHeader/filter.svg'
import FiltersHeader from '../../../components/Stock/FiltersHeader'
import TableFiltersContext from '../../../contexts/TableFiltersContext'
import SectionContext from '../../../contexts/SectionContext'
import refresh_act from '../../../assets/refresh-active.svg'
import resource from '../../../assets/home/resource.svg'
import steel from '../../../assets/home/steel.svg'
import { CompanyTypes, FilterTypesDiv } from '../../../components/Stock/TableMovementHeader/style'
import axios from '../../../config/axios'
import ProductFinals from '../ProductFinal'
import { ArrowDown } from 'lucide-react'

export interface StockOutletType {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
  fields: FieldsManagerType
  setIsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>
  quantity: number
  setQuantity: React.Dispatch<React.SetStateAction<number>>
}

const tabs = [
  { path: '/panel/stock', image: stock, name: 'Matéria prima', external: false },
  { path: '/panel/stock/resource', image: resource, name: 'Insumos', external: false },
  { path: '/panel/product-final', image: steel, name: 'Produto engenheirado', external: true }
]

const StockSubHeader:React.FC<{tabIndexActived:number, handleTabChange: (index: number) => void}> = ({tabIndexActived, handleTabChange}) => {
  const navigate = useNavigate()
  const companyTypesIds = ['Pedido', 'Manual']
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { stockFilters } = useContext(TableFiltersContext)
  const { resetContext, setRefresh: setContextRefresh, isLoading } = useContext(StockContext)
  const [isFiltersMenuOpen, setIsFiltersMenuOpen] = useState<boolean>(false)
  const filterMenuRef = useRef<HTMLDivElement>(null)
  const filterDropdownRef = useRef<HTMLDivElement>(null)
  const { movementTypeFilter, setMovementTypeFilter } = useContext(TableFiltersContext)
  const [stockInfo, setStockInfo] = useState({ totalWeight: 0, totalItems: 0 })

  const sectionTitles = ["Estoque", "Insumos", "Produtos engenheirado"]
  const currentTitle = sectionTitles[tabIndexActived] || "Estoque"
  

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterMenuRef.current &&
        filterDropdownRef.current &&
        !filterMenuRef.current.contains(event.target as Node) &&
        !filterDropdownRef.current.contains(event.target as Node)
      ) {
        setIsFiltersMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

     const fetchStockInfo = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/stock/getTotalStock`); // Substitua pela URL correta da sua API
      setStockInfo(response.data);
    } catch (error) {
      console.error('Erro ao buscar dados do estoque:', error);
    }
  };


  useEffect(() => {
    fetchStockInfo(); 
  }, []);

  const handleSetTypes = (id: string) => {
    if (movementTypeFilter.includes(id)) {
      if (movementTypeFilter.split(',').length === 1) {
        return
      }
      setMovementTypeFilter(
        movementTypeFilter
          .split(',')
          .filter((item) => item !== id)
          .join(',')
      )
    } else {
      setMovementTypeFilter(movementTypeFilter ? `${movementTypeFilter},${id}` : id)
    }
  }

  const openModal = () => {
    resetContext()
    setModalActive(true)
    setModalSection('addStockMenu')
    
  }
  const openExportModal = () => {
    const filters = stockFilters
    const columns = JSON.parse(localStorage.getItem('tableFields')|| '[]')[1].whichFieldsToShow.filter((field: { checked: boolean, field: string, fieldName: string }) => field.checked)
    const body = {
      filters,
      columns
    }
    navigate('/panel/stock/export')
  }
  
  return(
    <SubHeaderContainer>
    <LeftSide>
      <SectionName title={`Peso total: ${stockInfo.totalWeight.toLocaleString('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})} kg\nItens totais: ${stockInfo.totalItems}`}>Estoque</SectionName>
      <TabsDiv>
  {tabs.map((tab, index) => (
    <Tab
      key={index}
      $isFirst={index === 0}
      $isLast={index === tabs.length - 1}
      $isActive={index === tabIndexActived}
      onClick={() => {
        if (index !== tabIndexActived) {
          handleTabChange(index)
          if (tab.external) {
            navigate(tab.path)
            return
          }
          navigate(tab.path)
        }
      }}
    >
      <img src={tab.image} alt={`${tab.path}-icon`} />
      {tab.name}
    </Tab>
  ))}
</TabsDiv>
    </LeftSide>
    <RightSide>
  {tabIndexActived === 1 ?
  <ButtonCreate onClick={() => navigate('/panel/stock/resource/create')}>+ Adicionar Insumo</ButtonCreate>
        /* <FilterTypesDiv>
          {companyTypesIds.map((item) => (
            <CompanyTypes
              key={item}
              className={movementTypeFilter.includes(item) ? 'actived' : ''}
              onClick={() => handleSetTypes(item)}
            >
              {item}
            </CompanyTypes>
          ))}
        </FilterTypesDiv> */
      : null}
      {tabIndexActived === 0 ?
        <>
          <RefreshIconContainer onClick={() => setContextRefresh((prev: boolean) => !prev)} title="Atualizar">
            <RefreshIcon
              src={refresh_act}
              alt="Movement icon"
              $spinning={!!isLoading}
            />
          </RefreshIconContainer>
      <OptionsButton
        onClick={() => setIsFiltersMenuOpen(!isFiltersMenuOpen)}
        ref={filterMenuRef}
      >
        <img src={filter}alt="filter-icon" />
      </OptionsButton>
        </>
    : null}
      {tabIndexActived === 0 ?
      <>
        <ButtonCreate onClick={() => openExportModal()}>Exportar estoque</ButtonCreate>
      <ButtonCreate onClick={() => openModal()}>+ Adicionar estoque</ButtonCreate>
      </>
      : null}
  {isFiltersMenuOpen ? <FiltersMenu ref={filterDropdownRef} anchorRef={filterMenuRef} /> : null}
      
     
    </RightSide>
    
  </SubHeaderContainer>
  )
}

const StockContent = () => {
  const [ isdropdownOpen, setIsDropdownOpen ] = useState(false)
  const location = useLocation()
  const [ tabIndex, setTabIndex ] = useState<number>(0)
  const { search } = useOutletContext<TypeMainOutlet>()
  const { stockFilters, movementFilters } = useContext(TableFiltersContext)
  const { stockSection } = useContext(SectionContext)
  const { stockList, hasMoreStock, isLoading } = useContext(StockContext)
  const fromLocalStorage = localStorage.getItem('tableFields')
  const [ quantity, setQuantity ] = useState(10)
  
  const tableFieldsJson:FieldsManagerType[] = fromLocalStorage ? JSON.parse(fromLocalStorage) : tableFields
  const foundFields = tableFieldsJson.find(field => field.tableSection === 'stock')
  const defaultFromTable = tableFields.find(field => field.tableSection === 'stock') || tableFields[0]
  
  // Se não encontrou fields no localStorage ou nenhum campo está marcado, usa os defaults
  const defaultFields = (foundFields && foundFields.whichFieldsToShow.some(field => field.checked)) 
    ? foundFields 
    : defaultFromTable
  const [ section, setSection ] = useState<'stock' | 'movement' | 'resource'>('stock')
  const [ fields, setFields ] = useState<FieldsManagerType>(defaultFields as FieldsManagerType)
  const headerTabIndex = section === 'resource' ? 1 : 0

  useEffect(() => {
    if (section === 'resource') {
      return
    }
    const toLocalStorage = tableFieldsJson.map((table:FieldsManagerType) => {
      if(table.tableSection === section) {
        return {...table, whichFieldsToShow: fields.whichFieldsToShow}
      }
      return table
    })

    localStorage.setItem('tableFields', JSON.stringify(toLocalStorage))
  }, [fields, section])
  
  useEffect(() => {
    if (section === 'resource') {
      setIsDropdownOpen(false)
      return
    }
    const updatedFields = tableFieldsJson.find(field => field.tableSection === section)
    const defaultFromTable = tableFields.find(field => field.tableSection === section)
    
    // Se encontrou fields no localStorage mas nenhum está marcado, usa os defaults
    const fieldsToUse = (updatedFields && updatedFields.whichFieldsToShow.some(field => field.checked)) 
      ? updatedFields 
      : defaultFromTable
      
    if (fieldsToUse) {
      setFields(fieldsToUse)
    }
  }, [section])

  useEffect(() => {
    const basePath = '/panel/stock'
    if (!location.pathname.startsWith(basePath)) {
      setSection('stock')
      setTabIndex(0)
      return
    }

    const remainder = location.pathname.slice(basePath.length)
    const segments = remainder.split('/').filter(segment => segment.length > 0)
    const primarySegment = segments[0] || ''

    if (primarySegment === 'movement') {
      setSection('movement')
      setTabIndex(0)
      return
    }

    if (['resource', 'create', 'edit', 'view'].includes(primarySegment)) {
      setSection('resource')
      setTabIndex(1)
      return
    }

    setSection('stock')
    setTabIndex(0)
  }, [location.pathname])

  const handleTabSelection = (index: number) => {
    if (index === 1) {
      setSection('resource')
      setTabIndex(1)
      return
    }

    if (index === 0) {
      setSection('stock')
      setTabIndex(0)
      return
    }

    setTabIndex(index)
  }

  const renderSubHeader = () => {
    if (location.pathname.includes('panel/product-final')) {
      return <ProductFinals />
    }
  return <StockSubHeader tabIndexActived={headerTabIndex} handleTabChange={handleTabSelection} />
  }

  const shouldShowFieldManager = section !== 'resource'
  const hasSelectedFields = fields?.whichFieldsToShow?.some(field => field.checked)

  const outletContext = {
  tabIndex,
  setTabIndex,
    search,
    fields,
    setIsDropdownOpen,
    quantity,
    setQuantity,
    // kept minimal: refresh moved to StockContext
  }

  return (
    <>
      {renderSubHeader()}
      {shouldShowFieldManager && stockSection === 'stock' && stockFilters.length > 0 ? <FiltersHeader /> : null}
      {shouldShowFieldManager && stockSection === 'movement' && movementFilters.length > 0 ? <FiltersHeader /> : null}
      <Content>
        {shouldShowFieldManager && isdropdownOpen ? <FieldsManager dropdownOpen={setIsDropdownOpen} fields={fields} setFields={setFields}/> : null}
        {shouldShowFieldManager && !hasSelectedFields ? 
          <WithoutSelectedFields dropdown={setIsDropdownOpen} /> 
        :
          <Outlet
            context={outletContext}
          />
        }
      </Content>
      {/* Load more button moved into the Stock table footer so it stays inside the table scroll */}
    </>
  );
};

export default StockContent;